import { render } from "./klb-q6.vue?vue&type=template&id=53efe5e3&scoped=true"
import script from "./klb-q6.vue?vue&type=script&lang=js"
export * from "./klb-q6.vue?vue&type=script&lang=js"

import "./klb-q6.vue?vue&type=style&index=0&id=53efe5e3&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53efe5e3"]])

export default __exports__